var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer",
    class: {
      'drawer--open': _vm.drawer.open
    }
  }, [_c('div', {
    staticClass: "drawer__title"
  }, [_vm._v("\n    Change question\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "drawer__items"
  }, _vm._l((_vm.questions), function(question) {
    return _c('li', {
      staticClass: "drawer__item",
      on: {
        "click": function($event) {
          _vm.handlePick(question)
        }
      }
    }, [_vm._v("\n      " + _vm._s(question.name) + "\n    ")])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f9589c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/Drawer.vue
// module id = 7BLg
// module chunks = 1